import importScript from "qxjs/lib/core/importScript";
import ShareProcessor from "qxjs/lib/modules/vuewx/wechat/processors/Share";
import Sdk from "qxjs/lib/modules/vuewx/Sdk";
import { getWxConfig } from "../../api/wx";
import events from "../vue/events";

const WX_SDK_URL = `https://res.wx.qq.com/open/js/jweixin-1.6.0.js`;
const wechatDirectiveProcessors = [new ShareProcessor()];

export const sdk = new Sdk({
  configUrlGetter() {
    return window.location.href.split("#")[0];
  },
  configGetter(targetUrl) {
    return getWxConfig({
      url: encodeURIComponent(targetUrl),
    });
  },
  async importSdk() {
    const sdkUrl = WX_SDK_URL;
    return importScript(sdkUrl).then(() => {
      return import("qxjs/lib/modules/vuewx/wechat/WechatSdk");
    });
  },
  directiveProcessors: wechatDirectiveProcessors,
  events: events,
});
